import styled from 'styled-components';

export const PersonalDataContainer = styled.div`
  margin-bottom: 99px;

  @media (max-width: 1200px) {
    margin-bottom: 0;
  }

  .container-fields-personal-data {
    display: flex;
    flex-direction: column;
    gap: 24px;
  }
`;

export const LineFieldsContainer = styled.div`
  display: flex;
  flex-flow: row wrap;
  gap: 16px;
  align-items: flex-start;

  @media (max-width: 1200px) {
    > div {
      width: 100% !important;
      margin: 0;
      gap: 0;
    }
  }
`;
